import { CollateralBasketStatus } from 'api'
import { Translation, Locale } from 'locale'
import * as constants from 'view/styles/constants'

export function getCollateralBasketStatusColor(status: CollateralBasketStatus): string {
  switch (status) {
    case CollateralBasketStatus.ACTIVE:
      return constants.STATUS_COLOR_ACTIVE
    case CollateralBasketStatus.SUSPENDED:
      return constants.STATUS_COLOR_DEFAULT
    case CollateralBasketStatus.EXPIRED:
      return constants.STATUS_COLOR_EXPIRING
    case CollateralBasketStatus.DELETED:
      return constants.STATUS_COLOR_INVALID
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}

export function getCollateralBasketStatusText(status: CollateralBasketStatus): string {
  switch (status) {
    case CollateralBasketStatus.ACTIVE:
      return Locale.translate(Translation.TC_ACTIVE)
    case CollateralBasketStatus.SUSPENDED:
      return Locale.translate(Translation.TC_SUSPENDED)
    case CollateralBasketStatus.EXPIRED:
      return Locale.translate(Translation.TC_EXPIRED)
    case CollateralBasketStatus.DELETED:
      return Locale.translate(Translation.TC_DELETED)
    default:
      throw new Error(`Unhandled status [${status}]`)
  }
}
